import React, { useMemo } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import 'highcharts/modules/treemap';

const TopicTreemap = ({ topics_hierarchy_data }) => {
  const options = useMemo(
    () => ({
      chart: {
        type: 'treemap',
        height: 800,
        margin: [50, 50, 50, 50]
      },
      title: {
        text: '',
      },
      exporting: {
        sourceWidth: 800,
        sourceHeight: 600
      },
      legend: {
        enabled: true,
        align: 'right',
        verticalAlign: 'middle',
        layout: 'vertical',
        title: {
          text: 'Positive share',
          style: {
            fontSize: '13px',
            fontWeight: '500',
            color: '#64748b'
          }
        },
        valueDecimals: 0,
        valueSuffix: '%',
        symbolHeight: 250,
        symbolWidth: 25
      },
      tooltip: {
        useHTML: true,
        backgroundColor: '#0f172a',
        borderRadius: 6,
        style: { color: '#fff' },
        formatter() {
          const c = this.point.custom || {};
          return `
          <div style="min-width:180px">
            <b>${this.point.name}</b><br/>
            Mentions: <b>${c.value ?? '-'}</b><br/>
            Positive: <b>${c.positivePct ?? 0}%</b><br/>
            Negative: <b>${c.negativePct ?? 0}%</b>
          </div>
        `;
        }
      },
      series: [
        {
          type: 'treemap',
          name: 'Topic',
          layoutAlgorithm: 'squarified',
          allowTraversingTree: true,
          alternateStartingDirection: true,
          dataLabels: {
            format: '{point.name}',
            style: {
              textOutline: 'none'
            },
            allowOverlap: true
          },
          borderRadius: 3,
          borderColor: '#494949',
          borderWidth: 3,
          data: topics_hierarchy_data,
          levels: [
            {
              level: 1,
              layoutAlgorithm: 'squarified',
              groupPadding: 3,
              allowOverlap: false,
              dataLabels: {
                headers: true,
                enabled: true,
                style: {
                  fontSize: '13px',
                  fontWeight: '700',
                  textTransform: 'uppercase',
                  color: '#1e293b'
                }
              },
              borderRadius: 3,
              borderWidth: 4,
              borderColor: '#494949',
              colorByPoint: false,
              backgroundColor: '#DC0000'
            },
            {
              level: 2,
              layoutAlgorithm: 'squarified',
              groupPadding: 5,
              allowOverlap: false,
              dataLabels: {
                headers: false,
                enabled: true,
                style: {
                  fontSize: '13px',
                  fontWeight: '600',
                  color: '#1e293b',
                  textOutline: 'none'
                }
              },
              borderRadius: 3,
              borderWidth: 2
            }

          ]
        }
      ],
      exporting: {
        enabled: false
      },
      credits: { enabled: false }
    }),
    [topics_hierarchy_data]
  );

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default TopicTreemap;
